import type { IconData } from '@stacksjs/iconify-core'

export const shoppingClothes: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 0v1a3 3 0 0 0 6 0V0h5v7h-2v9H2V7H0V0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingClothes
